<template>
    <v-container fluid tag="section">
        <material-card color="primary" icon="mdi-credit-card">
            <template #title>
                Банківський продукт
            </template>

            <ButtonComeBack class="ml-3 mb-3" />
            <v-col cols="12" lg="6">
                <v-form lazy-validation v-model="isValidForm" ref="form">
                    <v-row>
                        <!--Проекти-->
                        <v-col cols="12">
                            <v-switch v-model="bank.enabled" label="Включено"></v-switch>
                        </v-col>
                        <!-- Код банку -->
                        <v-col cols="12">
                            <v-text-field label="Код продукту" v-model="bank.code" required
                                :rules="[v => !!v || errorRequired]" />
                        </v-col>
                        <!-- Кількість платежів	Ціле число	-->
                        <v-col cols="12">
                            <v-text-field label="Кількість платежів" v-model="bank.number_of_payments" type="number" required
                                :rules="[v => (v !== '' && v !== null && v !== undefined && Number(v) >= 0) || errorRequired]" />
                        </v-col>
                    </v-row>

                    <!--Табы-->
                    <v-col cols="12">
                        <v-tabs v-model="tab">
                            <v-tab v-for="local in localization" :key="local.lang_key">
                                {{ local.name }}
                            </v-tab>
                        </v-tabs>
                    </v-col>

                    <!--Содержымое табов-->
                    <v-col cols="12">
                        <v-tabs-items v-model="tab">
                            <v-tab-item v-for="(item, index) in bank.langs" :key="item.lang_key" :eager="true">
                                <template>
                                    <!--Назва-->
                                    <v-text-field label="Назва" v-model="item.name" required
                                        :rules="[v => !!v || errorRequired]" />
                                </template>
                            </v-tab-item>
                        </v-tabs-items>
                    </v-col>

                    <!--Кнопки-->
                    <v-col cols="12" class="text-right">
                        <v-btn color="primary" min-width="150" @click="sendForm()">
                            Зберегти
                        </v-btn>
                    </v-col>
                    <Preloader v-if="isSending" />
                </v-form>
            </v-col>

        </material-card>
    </v-container>
</template>

<script>
import { HTTP } from '@/http-common';
import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
    name: 'PageBankAdd',
    props: {
        id: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            bank: {
                id: null,
                enabled: true,
                number_of_payments: '',
                langs: [],
            },
            bankData: [],
            // Активный таб
            tab: 0,
            isValidForm: true,
            errorRequired: `Це поле обов'язкове`,
            isSending: false,
        }
    },
    computed: {
        ...mapGetters(['snackbar', 'localization'])
    },
    mounted() {
        this.init();
    },

    methods: {
        ...mapMutations(['setSnackbar']),
        ...mapActions(['getLocalization']),
        // Подготовка данных
        async init() {
            if (this.id) {
                const bankData = await HTTP.post('/get-bank-product', { id: this.id });
                this.bankData = bankData.data.content;
                const d = this.bankData;
                this.bank = {
                    id: this.id,
                    enabled: d[0].enabled,
                    code: d[0].code,
                    number_of_payments: d[0].number_of_payments,
                    langs: [],
                };
            }
            await this.getLocalization();

            this.bank.langs = this.localization.map((el) => {
                return {
                    lang_key: el.lang_key,
                    lang_name: el.name,
                    name: this.bankData.find(item => item.lang_id === el.lang_id)?.name || '',
                };
            });
        },
        // Создать список ошибок (ошибки надо показать в попапе - потому что табы)
        createListErrors() {
            let errors = '';
            for (let item of this.bank.langs) {
                if (!item.name) {
                    errors += `Помилка в табi "${item.lang_name}"</br>`;
                }
            }
            return errors;
        },

        // Отправка формы
        async sendForm() {
            this.errorDate = '';

            if (!this.$refs.form.validate()) {
                let errors = this.createListErrors();
                if (errors) {
                    this.setSnackbar({ type: 'error', text: errors });
                };
                return;
            };

            this.isSending = true;

            try {
                if (this.id) {
                    await HTTP.post("/update-bank-product", {
                        id: this.id,
                        ...this.bank,
                        langs: this.bank.langs.map((el) => {
                            return {
                                lang_key: el.lang_key,
                                name: el.name,
                            };
                        })
                    });
                    this.setSnackbar({ type: 'success', text: 'Успiшно збережено' });
                        this.isSending = false;
                } else {
                    let { data } = await HTTP.post("/create-bank-product", {
                        ...this.bank,
                        langs: this.bank.langs.map((el) => {
                            return {
                                lang_key: el.lang_key,
                                name: el.name,
                            };
                        })
                    });
                    this.setSnackbar({ type: 'success', text: 'Успiшно збережено' });
                    this.$router.push(`/bank-product/${data.content.id}/`);
                }
            } catch (error) {
                console.warn(error);
                this.setSnackbar({ type: 'error', text: error?.response?.data?.message || 'Помилка сервера' });
                this.isSending = false;
            }
        },

    },
}
</script>

<style scoped lang="sass">
.form-bank-add
  position: relative
</style>
